import { render } from "./MultiIcon.vue?vue&type=template&id=e22eb056&ts=true"
import script from "./MultiIcon.vue?vue&type=script&lang=ts"
export * from "./MultiIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__